// Press (/press, 2026-10-12): the shared chrome, and one analytics event per press link, media email and kit file.
// Tracking is local for the same reason as js/links.js (the theme's scratch.js doesn't export track()).
import { $, $$, initChrome } from 'v2/ui.js';
import { optedOut } from 'v2/privacy.js';

initChrome();

const track = (event, props = {}) => {
  if (!optedOut()) {
    try { window.posthog?.capture?.(event, props); } catch { /* analytics never break the page */ }
  }
  document.dispatchEvent(new CustomEvent('proda:track', { detail: { event, ...props } }));
};

$$('[data-forbes-link], [data-instagram-link], [data-press], [data-kit], [data-press-item]').forEach((el) => {
  el.addEventListener('click', () => {
    const target = el.dataset.press || el.dataset.kit || el.dataset.pressItem || ('instagramLink' in el.dataset ? 'instagram' : 'forbes');
    track('press_click', { target, href: el.getAttribute('href') || '' });
  });
});

// The coverage, and each of its two groups (featured cards, the list), stays hidden until it has an article (on
// Shopify both are the section's blocks).
$$('[data-press-group]').forEach((group) => { if (!group.querySelector('li')) group.hidden = true; });
const more = $('[data-press-more]');
if (more && !more.querySelector('li')) more.hidden = true;
